import { IHealthProblemHocSinhItemRequest } from '../../../models/request/y-te/yTeRequests';
import {
	IHealthProblemByHocSinhRequest,
	IStudentMedicalHistoryDetailSelectRequest,
	IStudentMedicalHistorySelectRequest
} from '../../../models/request/y-te/studentMedicalHistoryRequests';
import {
	HealthProblemHocSinhItemResponse,
	StudentMedicalHistoryDetailItemResponse,
	StudentMedicalHistoryItemResponse
} from '../../../models/response/y-te/healthproblem';
import { IStudentMedicalHistoryHocSinh } from '../../../models/response/y-te/studentMedicalHistory';

export enum eStudentMedicalHistoryActionTypeIds {
	LOAD_START = "STUDENT_MEDICAL_HISTORY_LOAD_START",
	LOAD_SUCCESS = "STUDENT_MEDICAL_HISTORY_LOAD_SUCCESS",
	LOAD_ERROR = "STUDENT_MEDICAL_HISTORY_LOAD_ERROR",

	LOAD_EXPORT_START = "STUDENT_MEDICAL_HISTORY_LOAD_EXPORT_START",
	LOAD_EXPORT_SUCCESS = "STUDENT_MEDICAL_HISTORY_LOAD_EXPORT_SUCCESS",
	LOAD_EXPORT_ERROR = "STUDENT_MEDICAL_HISTORY_LOAD_EXPORT_ERROR",
	EXPORT_COMPLETED = "STUDENT_MEDICAL_HISTORY_EXPORT_COMPLETED",

	LOAD_HOC_SINH_START = "STUDENT_MEDICAL_HISTORY_LOAD_HOC_SINH_START",
	LOAD_HOC_SINH_SUCCESS = "STUDENT_MEDICAL_HISTORY_LOAD_HOC_SINH_SUCCESS",
	LOAD_HOC_SINH_ERROR = "STUDENT_MEDICAL_HISTORY_LOAD_HOC_SINH_ERROR",
	CHANGE_HOC_SINH_SELECTED = "STUDENT_MEDICAL_HISTORY_CHANGE_HOC_SINH_SELECTED",

	LOAD_BY_HOC_SINH_START = "STUDENT_MEDICAL_HISTORY_LOAD_BY_HOC_SINH_START",
	LOAD_BY_HOC_SINH_SUCCESS = "STUDENT_MEDICAL_HISTORY_LOAD_BY_HOC_SINH_SUCCESS",
	LOAD_BY_HOC_SINH_ERROR = "STUDENT_MEDICAL_HISTORY_LOAD_BY_HOC_SINH_ERROR",
	CHANGE_HEALTH_PROBLEMS = "STUDENT_MEDICAL_HISTORY_CHANGE_HEALTH_PROBLEMS",

	SAVE_START = "STUDENT_MEDICAL_HISTORY_SAVE_START",
	SAVE_SUCCESS = "STUDENT_MEDICAL_HISTORY_SAVE_SUCCESS",
	SAVE_ERROR = "STUDENT_MEDICAL_HISTORY_SAVE_ERROR",

	SHOW_CONFIRM = "STUDENT_MEDICAL_HISTORY_SHOW_CONFIRM",
	CLOSE_CONFIRM = "STUDENT_MEDICAL_HISTORY_CLOSE_CONFIRM",

	DELETE_START = "STUDENT_MEDICAL_HISTORY_DELETE_START",
	DELETE_SUCCESS = "STUDENT_MEDICAL_HISTORY_DELETE_SUCCESS",
	DELETE_ERROR = "STUDENT_MEDICAL_HISTORY_DELETE_ERROR"
}

export interface IStudentMedicalHistoryLoadStart {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_START,
	payload: IStudentMedicalHistorySelectRequest
}
export interface IStudentMedicalHistoryLoadSuccess {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_SUCCESS,
	payload: StudentMedicalHistoryItemResponse[]
}
export interface IStudentMedicalHistoryLoadErr {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IStudentMedicalHistoryLoadExportStart {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_START,
	payload: IStudentMedicalHistoryDetailSelectRequest
}
export interface IStudentMedicalHistoryLoadExportSuccess {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_SUCCESS,
	payload: StudentMedicalHistoryDetailItemResponse[]
}
export interface IStudentMedicalHistoryLoadExportErr {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_ERROR,
	payload: string
}
export interface IStudentMedicalHistoryExportCompleted {
	type: eStudentMedicalHistoryActionTypeIds.EXPORT_COMPLETED
}
export interface IStudentMedicalHistoryLoadHocSinhStart {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_START,
	payload: number
}
export interface IStudentMedicalHistoryLoadHocSinhSuccess {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_SUCCESS,
	payload: IStudentMedicalHistoryHocSinh
}
export interface IStudentMedicalHistoryLoadHocSinhErr {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_ERROR,
	payload: string
}
export interface IStudentMedicalHistoryChangeHocSinhSelected {
	type: eStudentMedicalHistoryActionTypeIds.CHANGE_HOC_SINH_SELECTED,
	payload: IStudentMedicalHistoryHocSinh
}
export interface IStudentMedicalHistoryLoadByHocSinhStart {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_START,
	payload: IHealthProblemByHocSinhRequest
}
export interface IStudentMedicalHistoryLoadByHocSinhSuccess {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_SUCCESS,
	payload: HealthProblemHocSinhItemResponse[]
}
export interface IStudentMedicalHistoryLoadByHocSinhErr {
	type: eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_ERROR,
	payload: string
}
export interface IStudentMedicalHistoryChangeHealthProblems {
	type: eStudentMedicalHistoryActionTypeIds.CHANGE_HEALTH_PROBLEMS,
	payload: HealthProblemHocSinhItemResponse[]
}
export interface IStudentMedicalHistorySaveStart {
	type: eStudentMedicalHistoryActionTypeIds.SAVE_START,
	payload: IHealthProblemHocSinhItemRequest
}
export interface IStudentMedicalHistorySaveSuccess {
	type: eStudentMedicalHistoryActionTypeIds.SAVE_SUCCESS
}
export interface IStudentMedicalHistorySaveErr {
	type: eStudentMedicalHistoryActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IStudentMedicalHistoryShowConfirm {
	type: eStudentMedicalHistoryActionTypeIds.SHOW_CONFIRM
}
export interface IStudentMedicalHistoryCloseConfirm {
	type: eStudentMedicalHistoryActionTypeIds.CLOSE_CONFIRM
}
export interface IStudentMedicalHistoryDeleteStart {
	type: eStudentMedicalHistoryActionTypeIds.DELETE_START,
	payload: IHealthProblemByHocSinhRequest
}
export interface IStudentMedicalHistoryDeleteSuccess {
	type: eStudentMedicalHistoryActionTypeIds.DELETE_SUCCESS
}
export interface IStudentMedicalHistoryDeleteErr {
	type: eStudentMedicalHistoryActionTypeIds.DELETE_ERROR,
	payload: string
}

export type IStudentMedicalHistoryActionTypes = IStudentMedicalHistoryLoadStart | IStudentMedicalHistoryLoadSuccess | IStudentMedicalHistoryLoadErr |
	IStudentMedicalHistoryLoadExportStart | IStudentMedicalHistoryLoadExportSuccess | IStudentMedicalHistoryLoadExportErr |
	IStudentMedicalHistoryExportCompleted |
	IStudentMedicalHistoryLoadHocSinhStart | IStudentMedicalHistoryLoadHocSinhSuccess | IStudentMedicalHistoryLoadHocSinhErr |
	IStudentMedicalHistoryChangeHocSinhSelected |
	IStudentMedicalHistoryLoadByHocSinhStart | IStudentMedicalHistoryLoadByHocSinhSuccess | IStudentMedicalHistoryLoadByHocSinhErr |
	IStudentMedicalHistoryChangeHealthProblems |
	IStudentMedicalHistorySaveStart | IStudentMedicalHistorySaveSuccess | IStudentMedicalHistorySaveErr |
	IStudentMedicalHistoryShowConfirm | IStudentMedicalHistoryCloseConfirm |
	IStudentMedicalHistoryDeleteStart | IStudentMedicalHistoryDeleteSuccess | IStudentMedicalHistoryDeleteErr
